<template>
    <div class="calendar-page">
        <!-- tab部分 -->
        <div class="calendar-tab-box">
            <div class="calendar-tab dsp-flex">
                <div class="calendar-side" @click="clickToday">
                    <i class="iconfont icon-jin"></i>
                </div>
                <div class="calendar-menu dsp-flex">
                    <div class="calendar-menu-item" @click="toggleTab(1)"><span v-bind:class="{'cur': currentTab == 1}">公历</span></div>
                    <div class="calendar-menu-item" @click="toggleTab(2)"><span v-bind:class="{'cur': currentTab == 2}">农历</span></div>
                    <div class="calendar-menu-item" @click="toggleTab(3)"><span v-bind:class="{'cur': currentTab == 3}">古历</span></div>
                </div>
                <div class="calendar-side"></div> 
            </div>
        </div>
        <!-- 节气:古历 -->
        <div v-if="currentTab == 3" class="calendar-jieqi-box">
            <calendar-jie-qi></calendar-jie-qi>
        </div>
        <!-- 日历主体部分:公历 -->
        <div v-show="currentTab == 1 || currentTab == 2" class="calendar-box">
            <calendar-panel
                ref="calendarData"
                :events="calendarData.events" 
                :lunar="calendarData.lunar"
                :value="calendarData.value" 
                :begin="calendarData.begin" 
                :end="calendarData.end" 
                :weeks="calendarData.weeks" 
                :months="calendarData.months" 
                @select="calendarData.select"
                @selectMonth="calendarData.selectMonth"
                @selectYear="calendarData.selectYear">
            </calendar-panel>
        </div>

        <!-- 日历其他信息部分 -->
        <calendar-info v-if="currentTab != 3"></calendar-info>

        <!-- 弹框:选择时辰 -->
        <calendar-hour-pop></calendar-hour-pop>
        <!-- 弹框:公历农历选择时间 -->
        <calendar-date-pop></calendar-date-pop>
        <!-- 弹框:古历选择时间 -->
        <calendar-year-pop></calendar-year-pop>
    </div>
</template>

<script>
import CalendarPanel from '../components/calendar/CalendarPanel.vue'
import CalendarInfo from '../components/calendar/CalendarInfo.vue'
import CalendarHourPop from '../components/calendar/CalendarHourPop.vue'
import CalendarYearPop from '../components/calendar/CalendarYearPop.vue'
import CalendarDatePop from '../components/calendar/CalendarDatePop.vue'
import CalendarJieQi from '../components/calendar/CalendarJieQi.vue'
import { MIX } from '../modules/utils'
export default {
    name: 'Calendar',
    components: { CalendarPanel, CalendarInfo, CalendarHourPop, CalendarYearPop, CalendarDatePop, CalendarJieQi },
    computed: {
        currentTab() {
            return this.$store.state.calendar.currentTab
        }
    },
    data() {
        return {
            calendarData: {
                value: [],
                lunar: true, //显示农历
                showDisabled: false,
                events:{},
                select(value){
                    MIX.trackButtonClicked('calendar_select_time');
                    console.log('select----', value.toString());
                },
                selectMonth(month,year){
                    console.log('selectMonth----', year,month)
                },
                selectYear(year){
                    console.log('selectYear----', year)
                },
                timestamp: Date.now()
            }
        }
    },
    mounted() {
        var me = this;
        this.$store.dispatch('initBasicData', {
            cb: me.clickToday
        });
        setTimeout(() => {
            MIX.trackPageViewed('HuangLi');
        }, 20);
    },
    methods: {
        clickToday() {
            let now = new Date(),
                year = now.getFullYear(),
                month = now.getMonth(),
                day = now.getDate();
            // this.calendarData.value = [year, month+1, day];
            MIX.trackButtonClicked('calendar_today');
            if(this.currentTab == 1 || this.currentTab == 2) {
                this.$bus.emit('selectCalendar', {
                    value: [year, month, day],
                    calType: this.currentTab
                });
            }else if(this.currentTab == 3) {
                this.$bus.emit('selectJieQiToday');
                this.$store.dispatch('calendar/initCalendarJieQi', year);
            }
            this.$store.state.calendar.currentCalendarDate = now;
        },
        toggleTab(tabNum) {
            switch(tabNum) {
                case 1:
                    MIX.trackButtonClicked('calendar_tab_solar');
                    break;
                case 2:
                    MIX.trackButtonClicked('calendar_tab_lunar');
                    break;
                case 3:
                    MIX.trackButtonClicked('calendar_tab_history');
                    break;
                default:
                    break;
            }
            var me = this;
            if(tabNum == 1 || tabNum == 2) {
                this.$bus.emit('selectCalendar', {
                    calType: tabNum
                });
                // 第二次处理
                if(this.$store.state.calendar.currentTab == 3 && tabNum == 2) {
                    setTimeout(() => {
                        me.$bus.emit('selectCalendar', {
                            calType: tabNum
                        });
                    }, 0);
                }
            }
            this.$store.state.calendar.currentTab = tabNum;
        }
    }
 
}
</script>